import { themes } from "../MatxTheme/initThemes";
import layout1Settings from "./Layout1/Layout1Settings";

// UPDATE BELOW CODE
// DOC http://demos.ui-lib.com/matx-react-doc/layout.html
export const MatxLayoutSettings = {
  activeLayout: "layout1", // layout1, layout2
  activeTheme: "blue", // View all valid theme colors inside MatxTheme/themeColors.js
  perfectScrollbar: false,

  themes: themes,
  layout1Settings, // open Layout1/Layout1Settings.js

  secondarySidebar: {
    show: true,
    open: false,
    theme: "slateDark1", // View all valid theme colors inside MatxTheme/themeColors.js
  },
  // Footer options
  footer: {
    show: true,
    fixed: false,
    theme: "slateDark1", // View all valid theme colors inside MatxTheme/themeColors.js
  },

  // Add your custom palette here
  palette: {
    primary: "#ffffff", //white
    mediumBlack: "#88898c", //medium black
    mediumGrey: "#f5f5f7", //medium grey
    textBlack: "#606060", //textBlack

    black: "#2a2b32", //black
    white: "#ffffff", //white
    active: "#7c49fe", // violet
    yellow: "#f29339", // orange
    green: "#00a67e", //green
    purple: "#f1edfe", //purple
    maroon: "#ab4e52 ",
    dimMaroon: "#b0686bff ",

    // red
    danger: "#f44336", // red
    lightRed: "#ff958c", // light red
    dimRed: "#ff726759", // transparent red
    lightEventoRed: "#EB575733",

    // grey
    greySecondary: "#8c8c8c", // medium grey
    darkGrey: "#d1cfcf",
    lightGrey: "#f5f5f5",
    tableGrey: "#6C757D",
    tableRow: "#F8F9FA",
    iconGrey: "#4F4F4F",
    borderGrey: "#E2E2E2",

    //green
    lightGreen: "#f3faec",
    lightEventoGreen: "#09B2851A",
    shadeofEventoGreen: "#bbffdc",
    eventoGreen: "#09B285",
    dimGreen:"#EBF9F1",
    limeGreen:"#1F9254", 

    //orange
    orange:"#C99300",
    lightOrange: "#F2933945",

    // techversant theme
    techBlue: "#198CCB",
  },
};
